import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import SignUpForm, { SignUpFormInputs } from './Onboarding/SignupForm';

import { FieldErrors } from 'react-hook-form';
import OtpPage from './Onboarding/OtpPage';
import JobPreferrence from './Onboarding/JobPreferrence';
import AspireCareer, { Course } from './Onboarding/AspireCareer';
import CollegeInformation from '../Onboarding/CollegeInformation';

interface Props {
	currentStep: number;
	register?: any;
	errors: FieldErrors<SignUpFormInputs>;
	showOtpUi?: boolean;
	otp: string;
	setOtp: (otp: string) => void;
	setShowOtpUi: (showOtpUi: boolean) => void;
	phoneNumber: string;
	selectedDomain: string;
	selectedCourse: string;
	selectedSpec: string;
	selectedYear: string;
	setSelectedDomain: (domain: string) => void;
	setSelectedCourse: (course: string) => void;
	setSelectedSpec: (spec: string) => void;
	setSelectedYear: (year: string) => void;
	jobSelect: string;
	setJobSelect: (jobSelect: string) => void;
	selectedCourses: Course[];
	setSelectedCourses: (selectedCourses: Course[]) => void;
	isSignUpChecked: boolean;
	setIsSignUpChecked: React.Dispatch<React.SetStateAction<boolean>>;
	handleSignUpSendOtp: () => void;
}
const ProgressBody = ({
	selectedCourse,
	selectedDomain,
	selectedSpec,
	selectedYear,
	setSelectedCourse,
	setSelectedDomain,
	setSelectedSpec,
	setSelectedYear,
	phoneNumber,
	otp,
	setShowOtpUi,
	setOtp,
	currentStep,
	register,
	errors,
	showOtpUi,
	jobSelect,
	setJobSelect,
	selectedCourses,
	setSelectedCourses,
	isSignUpChecked,
	setIsSignUpChecked,
	handleSignUpSendOtp,
}: Props) => {
	const stepHeaderText = {
		1: {
			heading: 'Please provide your',
			subHeading: 'basic information.',
		},
		2: {
			heading: 'Please provide your',
			subHeading: 'college information.',
		},
		3: {
			heading: 'Select your ',
			subHeading: 'job preference.',
		},
		4: {
			heading: 'You aspire to ',
			subHeading: 'start your career as',
		},
	};
	const getStepComponent = () => {
		switch (currentStep) {
			case 1:
				return (
					<Box>
						{showOtpUi ? (
							<OtpPage phoneNumber={phoneNumber} setShowOtpUi={setShowOtpUi} otp={otp} setOtp={setOtp} resendOtp={handleSignUpSendOtp} />
						) : (
							<SignUpForm isSignUpChecked={isSignUpChecked} setIsSignUpChecked={setIsSignUpChecked} errors={errors} register={register} />
						)}
					</Box>
				);
			case 2:
				return (
					<Box>
						<CollegeInformation
							selectedCourse={selectedCourse}
							selectedDomain={selectedDomain}
							selectedSpec={selectedSpec}
							selectedYear={selectedYear}
							setSelectedCourse={setSelectedCourse}
							setSelectedDomain={setSelectedDomain}
							setSelectedSpec={setSelectedSpec}
							setSelectedYear={setSelectedYear}
						/>
					</Box>
				);
			case 3:
				return (
					<Box>
						<JobPreferrence jobSelect={jobSelect} setJobSelect={setJobSelect} />
					</Box>
				);
			case 4:
				return (
					<Box>
						<AspireCareer selectedCourses={selectedCourses} setSelectedCourses={setSelectedCourses} />
					</Box>
				);
		}
	};

	return (
		<Box mb="16px">
			{showOtpUi ? null : (
				<Box mb="16px" display={'flex'} gap="4px" justifyContent={{ md: 'center' }}>
					<Heading as="h4">{currentStep}.</Heading>
					<Heading as="h4">
						{
							// @ts-ignore
							stepHeaderText[currentStep].heading
						}{' '}
						<Box as="br" display={{ base: 'block', md: 'none' }} />
						<Text ml={{ md: '4px' }} as="span" color={'#4358F6'}>
							{
								// @ts-ignore
								stepHeaderText[currentStep].subHeading
							}
						</Text>
					</Heading>
				</Box>
			)}
			<Box>{getStepComponent()}</Box>
		</Box>
	);
};

export default ProgressBody;
